<div class="" style="background-color: #b3ccff; height:100%;">
    <div class="card-body">
      <div class="row">
        <div class="col-xl-6"></div>
        <div class="col-xl-6">
          <!-- <a href=""><h5>
          <u style="float:right;cursor: pointer;font-size: 40px;"><i class="bi bi-house-fill" style="color:black;"></i></u>
        </h5></a> -->
       </div>
      </div>
        <div class="row">
          <div class="col-xl-6 mx-auto">
            <div class="row">
            <div class="row" class="text-center">
              <img src="./assets/img/board_logo.png" style="height: 7rem; width: 8rem;" class="mx-auto">
              <h1 class="title" id="title">Online Document Issuance Portal</h1>
            </div>
          <div class="row" style="text-align:center;">
              <p class="sub-title"><b>Welcome to GBSHSE Document Issuance Portal, Admin Panel.</b></p>
            </div>
      </div>
    <form  method="post" role="form" [formGroup]="Requestform" (ngSubmit)="onSubmit(Requestform.value)">
      <div class="row">
        <div class="col-md-10 mx-auto">
          <div class="row"> 
    <div class="form-group">
      <label class="label" for="input-user">Username:</label>
      <input (keydown)="hidewarningmsg()" type="text" formControlName="username" class="form-control  border-left-0" style="padding: 12px;"
      [ngClass]="{ 'is-invalid': submitted && f.username.errors }" placeholder="Username"/>
    <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
      <div *ngIf="f.username.errors.required">Please Provide your User Name</div>
    </div>
    </div>
  </div>
  
  <div class="row">
      <div class="form-group"><label class="label" for="input-password">Password:</label>
        <input (keydown)="hidewarningmsg()" [type]="typetext1 ? 'text' : 'password'" formControlName="password" style="padding: 12px;" class="form-control  border-left-0"
            [ngClass]="{ 'is-invalid': submitted && f.password.errors }" placeholder=" Password"/>
            <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
              <div *ngIf="f.password.errors.required">Please Provide Password</div>
            </div>
    </div></div>
    <div class="row">
      <div class="form-control-group accept-group">
      <a class="forgot-password" (click)="gotoresetpassword()">Forgot Password?</a></div>
    </div>

    <div class="row">

      <div class="form-group">
      <ngx-recaptcha2 #captchaElem
      [siteKey]="siteKey" [ngClass]="{ 'is-invalid': submitted && f.recaptcha.errors }"
      formControlName="recaptcha">
      </ngx-recaptcha2>
      <div *ngIf="submitted && f.recaptcha.errors" class="invalid-feedback">
      <div *ngIf="f.recaptcha.errors.required">Recaptcha is required</div>
      </div>
      </div>
  </div>


        <div class="row">
          <div class="form-group">
          <button  class=" btn btn-success btn-full-width mt-4" type="submit"> Log In</button>
          </div>
        </div>
        </div>
        </div>
      </form>
      </div>
    </div>
   </div>
  </div>
  
  
  